import React, { useState } from "react";
import PageWrapper from "./components/PageWrapper";
import { useFormCtx } from "./FormContext";

import * as Const from "./_Const";

import Keyboard from "./components/Keyboard";
import Input from "./components/Input";

function PagePersonalFirstName({ onNext, onPrev }) {
  const { getPageData, handleInputWithKeyboard, state, setCurrentStepIndex, isEmptyState, isInErrorState } = useFormCtx();
  const index = Const.REG_RPI_NAME_INDEX;
  const page = getPageData(index);

  const showTitle = !Const.isTerminal();

  function canShowNext() {
    return state.firstName && !isInErrorState ? true : false;
  }

  return (
    <>
      <PageWrapper title={page.title} index={index} showTitle={showTitle} showNext={canShowNext()}>
        <div className="mt-4 flex flex-col space-y-4 mx-6">
          <Input
            label="Jméno"
            name="firstName"
            value={state.firstName}
            errorMessage={state.errors.firstName}
            autoComplete="off"
            showLabel={true}
            readOnly={true}
            showClearIcon={true}
            onClear={(e) => handleInputWithKeyboard("firstName", "")}
          />

          <Keyboard type={"text"} onChange={(e) => handleInputWithKeyboard("firstName", e)} value={state.firstName} />
        </div>
      </PageWrapper>
    </>
  );
}

export default PagePersonalFirstName;
